<div *ngIf="showTableRegisters" class="registrations-table">

<p-table
  #dt
  [value]="members"
  [rows]="10"
  [paginator]="true"
  [globalFilterFields]="[
    'idNumber',
    'name',
    'lastName',
    'club.name',
    'nivel',
    'birthDay',
    'gender'
  ]"
  [rowHover]="true"
  dataKey="idNumber"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showCurrentPageReport]="false"
  class="p-datatable-sm table'"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      <div style="text-align: left">
        <p-button
          icon="pi pi-external-link"
          m
          label="Exportar"
          (onClick)="exportGeneralReport()"
        />
      </div>
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search..."
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="club.name" class="table__header">
        Club <p-sortIcon field="rating" />
      </th>
      <th pSortableColumn="idNumber" class="table__header">
        Identificación <p-sortIcon field="name" />
      </th>
      <th pSortableColumn="name" class="table__header">Nombres</th>
      <th pSortableColumn="lastName" class="table__header">
        Apellidos <p-sortIcon field="price" />
      </th>

      <th pSortableColumn="birthDay" class="table__header">
        Fecha Nacimiento <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="level" class="table__header">
        Edad (Corte) <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="level" class="table__header">
        Nivel <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="categoria" class="table__header">
        Categoría <p-sortIcon field="inventoryStatus" />
      </th>

      <th pSortableColumn="gender" class="table__header">
        Rama <p-sortIcon field="rating" />
      </th>

      <th pSortableColumn="cross-selling" class="table__header" *ngIf="competition.hasCrosselling">
        Venta Cruzada <p-sortIcon field="rating" />
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-member>
    <tr class="table__row">
      <td>
        {{ member.club.name }}
      </td>

      <td>{{ member.idType }}{{ member.idNumber }}</td>
      <td>
        {{ member.name }}
      </td>
      <td>
        {{ member.lastName }}
      </td>

      <td>
        {{ member.birthDay }}
      </td>

      <td>
        {{ getCompetitionAge(member.birthDay) }}
      </td>

      <td>
        {{ member.nivel }}
      </td>

      <td>
        {{ getCategory(member)?.name }}
      </td>
      <td>
        {{ member.gender === "M" ? "MASCULINA" : "FEMENINA" }}
      </td>
      <td *ngIf="competition.hasCrosselling">
        {{getCrossSellingDescription(member.id)}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">
      {{ members ? members.length : 0 }} registros en total.
    </div>
  </ng-template>
</p-table>
</div>